<div class="flex justify-center items-center bg-gray-100 h-full">
  <div
   class="h-full w-full bg-white shadow-lg rounded-lg flex gap-8 pl-12 pt-12 pr-12 pb-4"
   [ngClass]="windowSize < 1024 ? 'justify-center' : 'justify-between'"
  >

    <div
      class="flex-col w-10/20 h-full"
      [ngClass]="windowSize < 1024 ? 'p-2' : 'p-16'"
    >
      <img
        src="assets/images/blue-logo-image.svg"
        alt="Logo"
        class="h-55 w-85"
      >
      <h2 class="text-2xl font-bold mb-2">Boas vindas!</h2>
      <p class="text-gray-600 mb-8">Faça seu login com uma das contas abaixo:</p>

      <form class="space-y-4" [formGroup]="form">
        <GenericInput
            [configs]="{
              formFieldType: 'outline',
              inputType: 'email',
              noLabel: false,
              inputLabel: 'E-mail',
              placeholder: 'contato@mail.com',
              controlName: 'email',
              inputValidators: getValidators('email'),
              class: 'w-full'
            }"
            [form]="form"
          >
          </GenericInput>

          <GenericInput
            [configs]="{
              formFieldType: 'outline',
              inputType: 'password',
              noLabel: false,
              labelClass: 'pt-2',
              inputLabel: 'Senha',
              placeholder: 'Ex. Senha123',
              controlName: 'password',
              inputValidators: getValidators('password'),
              class: 'w-full'
            }"
            [form]="form"
          >
          </GenericInput>

        <div
          class="flex items-center justify-between pt-4"
          [ngClass]="(windowSize < 661) || (windowSize > 1024 && windowSize < 1440)  ? 'flex-col gap-2' : ''"
        >
          <mat-checkbox
            class="remember-me"
            (change)="rememberMe = !rememberMe"
          >
            Lembrar-me
          </mat-checkbox>
          <a
            class="text-blue-500 text-sm"
            (click)="forgotPassword()"
          >
            Esqueceu a senha?
          </a>
        </div>

        <button
          mat-flat-button
          class="w-full submit-button"
          [disabled]="form.invalid"
          (click)=" loading ? null : login()"
        >
          @if(loading) {
            <mat-spinner
              class="loading-spinner"
              diameter="40"
              color="#FFF"
            >
            </mat-spinner>
          } @else {
            Acessar
          }
        </button>
      </form>
    </div>

    <div
      class="w-full h-full"
      [ngClass]="windowSize < 1024 ? 'hidden' : ''"
    >
      <img
        src="assets/images/login-page-image.png"
        alt="Vôlei"
        class="h-19/20 w-full rounded-lg object-cover"
      >
    </div>
  </div>
</div>
